/* eslint-disable react/no-unknown-property */
import 'bootstrap/dist/css/bootstrap.css';
import '@shopify/polaris/dist/styles.css';
import 'autoketing-new/dist/styles.css';

import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import Cookies from 'js-cookie';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import { AppProvider as ShopifyAppProvider } from '@shopify/polaris';
import { AppProvider } from 'autoketing-new';
import { ConnectedRouter } from 'connected-react-router/immutable';
import enTranslations from '@shopify/polaris/locales/en.json';
import { AutoketingProvider, autoketingStore } from './contexts/appProvider';
import { ToastProvider } from './contexts/toastProvider';
import { CrossSellProvider } from './contexts/crossSellBar';
import configureStore, { history } from './stores';
import { getUrlParams } from './helpers';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { ScrollToTop } from './components/autoketing-common';
import './assets/css/main.scss';

const store = configureStore(/* provide initial state if any */);
const shopDomain = getUrlParams('shop') || 'dev';
const hmac = getUrlParams('hmac');
const searchUrl = window.location.search;
window.shopifyAppReview = 'https://apps.shopify.com/upsell-cross-sell-smart-tool?reveal_new_review=true';

function AutoketingApp() {
  ReactGA.initialize(process.env.REACT_APP_GA_ID || '');
  const { state } = useContext(autoketingStore);
  if (shopDomain && hmac && window.location.search) {
    Cookies.set('autoketing_upsell_app_session', searchUrl, { expires: 30 });
  }
  return (
    <div data-theme={state.theme === 'dark' ? 'dark' : ''} nav-desktop={!state.isNavigationDesktop ? 'hide' : ''}>
      <ShopifyAppProvider
        i18n={enTranslations}
        features={{ newDesignLanguage: true }}
        theme={{
          colorScheme: state.theme
        }}
      >
        <AppProvider>
          <ToastProvider>
            <Provider store={store}>
              <ConnectedRouter history={history}>
                <ScrollToTop>
                  <App />
                </ScrollToTop>
              </ConnectedRouter>
            </Provider>
          </ToastProvider>
        </AppProvider>
      </ShopifyAppProvider>
    </div>
  );
}

ReactDOM.render(
  <AutoketingProvider>
    <CrossSellProvider>
      <AutoketingApp />
    </CrossSellProvider>
  </AutoketingProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
